window.findifyColorMapping = {
  "absinthe": "#4B7488",
  "absinthe + sky": "#4B7488",
  "abstra": "#E6A557",
  "agave tortoise": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Agave_Tort-Circle-01.png?v=1645042013",
  "agave mirror": "#D1C7D3",
  "allegra circle": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Alegra-Circle-01.png?v=1645042101",
  "almond tortoise": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Almond_Tortoise-Circle-01.png?v=1645042143",
  "almond": "#8B4D33",
  "americano": "#775139",
  "apollo": "#A7A09C",
  "apollo + twilight": "#A7A09C",
  "avalon": "#D2ADAD",
  "avalon + summer gold": "#D2ADAD",
  "banks": "#E5D898",
  "banks ligh": "#E5D898",
  "bengal tor": "#C15E15",
  "birch": "#A8764E",
  "black": "#000000",
  "black bourbon": "#40231F",
  "black fade": "#000000",
  "black smok": "#4B4B4B",
  "black and tan": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Black_and_Tan-Circle-01.png?v=1645042215",
  "bone": "#F8EEE4",
  "boston": "#603F36",
  "brandy": "#9F2515",
  "breeze": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Breeze-Circle.png?v=1676420154",
  "brindle tortoise": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Brindle_Tortoise-Circle-01.png?v=1645042393",
  "brown": "#745648",
  "brushed li": "#9A8059",
  "brushed light gold + khaki": "#9A8059",
  "brshsunshi": "#C6B39C",
  "brushed pe": "#9F9582",
  "brunette": "#8A3C25",
  "brut": "#F2F2E1",
  "burlwood": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Burlwood-Circle-01.png?v=1645042441",
  "canyon": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Canyon-Circle-01.png?v=1645042498",
  "canyon + spruce": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Canyon-Circle-01.png?v=1645042498",
  "cascad": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Cascade-Circle.png?v=1676420337",
  "cassis": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Cassis-Circle-01.png?v=1645042552",
  "cassis + kelp": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Cassis-Circle-01.png?v=1645042552",
  "cava": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Cava-Circle.png?v=1676420373",
  "cava + magnolia": "#EDE0D4",  
  "chai tortoise": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Chai_Tortoise-Circle-01.png?v=1645042695",
  "champagne crystal": "#C4B898",
  "charcoal tortoise": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Charcoal_Tortoise-Circle-01.png?v=1645042784",
  "charcoaol": "#494D4E",
  "chartr": "#72914D",
  "chestn": "#A65F55",
  "cherry cola": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Cherry_Cola-Circle-01.png?v=1645042867",
  "cherry cola + light gold": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Cherry_Cola-Circle-01.png?v=1645042867",
  "cherry": "#DE6C60",
  "cirus": "#4B7F8E",
  "clay": "#D08621",
  "cliff": "#9899A8",
  "cloud": "#C9CBCD",
  "clove": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Clove-Circle.png?v=1676420398",
  "coral tortoise": "https://cdn.shopify.com/s/files/1/0008/6156/9085/files/Coral_Tortoise-Circle.png?v=1656640430",
  "cosmos tortoise": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Cosmos_Tortoise-Diamond.png?v=1656641713",
  "cove": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Clove-Circle-01.png?v=1645042912",
  "cognac": "#761B00",
  "cold brew": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Cold_Brew-Circle-01.png?v=1645042971",
  "cold brew + azul": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Cold_Brew-Circle-01.png?v=1645042971",
  "coke bottl": "#91BA91",
  "cream": "#EFE7DF",
  "crystal black": "#000000",
  "crystal clear": "rgba(221, 221, 221, 0.5)",
  "dawn": "#E6D7D0",
  "dawn + polished summer gold": "#E6D7D0",
  "dusk": "#26314c",
  "ecru": "#F5D9CC",
  "ecru + rose": "#F5D9CC",
  "ember": "#DA9235",
  "emerald ro": "#F2DFD1",
  "emerald rose": "#F2DFD1",
  "emerald green": "#E2D3AB",
  "emerald rose + dawn": "#F2DFD1",
  "espresso tortoise": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Espresso_Tortoise-Circle-01.png?v=1645043123",
  "fading": "#442914",
  "fennel": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Fennel-Circle.png?v=1676420424",
  "fern": "#7B9C7E",
  "fernwood": "#C6C79F",
  "fernwood + skye": "#C6C79F",
  "fogcry": "#EBEBEB",
  "fog": "#C7C7C7",
  "fog crystal": "#C7C7C7",
  "french": "#D1CCC0",
  "ghost": "#836C54",
  "ghost + villa": "#836C54",
  "ginger": "#F3E7D0",
  "gold": "#BEA965",
  "gold + brindle tortoise": "#BEA965",
  "goldenhour": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/GoldenHour-Circle.png?v=1676420465",
  "gunmet": "#868686",
  "gunmetal": "#868686",
  "gunmetal + oxblood": "#868686",
  "grove": "#535D58",
  "haze": "#DEDAC2",
  "hazy lilac": "#D1C7D3",
  "hazy lilac + tahoe tortoise": "#D1C7D3",
  "holida": "#E1F2C5",
  "honey": "#DB8604",
  "huru": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Huru-Circle-01.png?v=1645041760",
  "infant": "#EABCB9",
  "jag": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Jag-Circle-V2-01.png?v=1645043161",
  "jag / bron": "#6A3E18",
  "jaguar": "#9a4a0c",
  "japane": "#E0CEB5",
  "juniper": "#A1B9AC",
  "kelp": "#895E28",
  "khaki": "#8E8258",
  "kiln + slate": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Kiln-Color-Swatch-Circle.png?v=1665533154",
  "kola tortoise": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Kola_Tortoise-Circle-01.png?v=1645043210",
  "kola tortoise + ember": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Kola_Tortoise-Circle-01.png?v=1645043210",
  "kola tortoise + juniper": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Kola_Tortoise-Circle-01.png?v=1645043210",
  "kola": "#591F02",
  "lagoon": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Lagoon-Circle.png?v=1676420516",
  "lactac": "#E7E2EB",
  "licorice": "#1D1F21",
  "light": "#F0E0A8",
  "lotus": "#6C5C82",
  "luna": "#4D507B",
  "magnolia": "#DDC8BD",
  "magnolia + myan": "#DDC8BD",
  "magnolia + suede": "#DDC8BD",
  "maple + dawn": "https://cdn.shopify.com/s/files/1/0008/6156/9085/files/Maple-Color-Swatch-Circle.png?v=1665533347",
  "marina": "#7CC4B1",
  "marin": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Marin-Circle-01.png?v=1645043262",
  "marine": "#647792",
  "matte blac": "#3B3B3B",
  "matte black": "#3B3B3B",
  "matte black + matte brindle": "#3B3B3B",
  "matte brindle tortoise": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Matte_Brindle_Tortoise-Circle-01.png?v=1645043326",
  "matte rootbeer": "#573626",
  "matte rose": "#B68A70",
  "mauve": "#5D4054",
  "mint": "https://cdn.shopify.com/s/files/1/0008/6156/9085/files/Mint-Circle.png?v=1676420576",
  "moab tortoise": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Moab_Tortoise-Circle-01.png?v=1645044398",
  "myan": "https://cdn.shopify.com/s/files/1/0008/6156/9085/files/Myan-Color-Swatch-Circle.png?v=1665533370",
  "navy": "#1C4689",
  "nectar": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Nectar-Circle.png?v=1676420604",
  "nero tortoise": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Nero_Tortoise-Circle-01.png?v=1645044437",
  "nylon": "#C5423D",
  "nomadi": "#282A2A",
  "nopal": "#A28D76",
  "nude": "#FEE1C9",
  "oak": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Oak-Circle-01.png?v=1645044796",
  "ocelot": "#E5D9B3",
  "ocelot + sunshine gold": "#E5D9B3",
  "onyx": "#6E6266",
  "orchid": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Orchid-Circle-01.png?v=1645044834",
  "oxblood": "#72100A",
  "pacific": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Pacific-Circle-01.png?v=1645044880",
  "paloma": "#E0B8BD",
  "palomino": "#C29B79",
  "panama": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Panama-Circle.png?v=1676420654",
  "papaya": "#DDAB78",
  "pebble": "#9D9C96",
  "pecan ": "#8D5841",
  "pinyon": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Pinyon-Circle-01.png?v=1645044938",
  "pinyon + emerald": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Pinyon-Circle-01.png?v=1645044938",
  "pistachio": "#9A823F",
  "peroxide": "#EBE7E7",
  "plum": "#6E4561",
  "powder": "#DEC4AE",
  "ridgel": "#9B9290",
  "ristre": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Ristretto-Circle.png?v=1676420682",
  "rootbeer": "#834A30",
  "rose": "#C7B2A5",
  "ruby r": "#A30008",
  "rush": "#C7CAE8",
  "salsa": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Salsa-Circle-01.png?v=1645044990",
  "samar": "#E8CE78",
  "sand d": "#A30008",
  "satin blac": "#312D2D",
  "satin black": "#312D2D",
  "satin black + brindle tortoise": "#312D2D",
  "satin dune": "#C4956F",
  "satin jpn ": "#E5D5A6",
  "satin japanese + gold sorrel": "#E5D5A6",
  "satin japanese gold + matte black": "#E4D5A5",
  "satin japanese gold + brindle tortoise": "#E4D5A5",
  "satin ligh": "#DAC5BD",
  "satin silv": "#DDDDDD",
  "satin silver": "#DDDDDD",
  "satin silver + rose": "#DDDDDD",
  "satin silk": "#D3AFB1",
  "satin silk + rose": "#D3AEB1",
  "satin blue": "#454B79",
  "satin blue japanese gold + absinthe": "#454B79",
  "satin japanse ": "#E5D5A6",
  "satin pink": "#B04E6F",
  "satin pink light gold + fog": "#B04E6F",
  "satin rose + op": "#C4BCB1",
  "satin rose + da": "#DEB994",
  "satin rose gold": "#D3B7A8",
  "satinrosegold/d": "#DEB994",
  "satin light rose gold + hazy lilac": "#DAC5BD",
  "savann": "#A68056",
  "self g": "#98C3A8",
  "seagra": "#766D05",
  "shadow": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Shadow-Circle.png?v=1676420705",
  "shiny gold": "#E0D3AF",
  "shiny nude gold": "#D6C1B4",
  "shiny ridg": "#CBC0BE",
  "shiny ligh": "#FCF1D0",
  "shinylight": "#FCF1D0",
  "shiny blac": "#938C78",
  "shiny black light gold + dawn": "#938C78",
  "shiny rose + da": "#EAD2BA",
  "shiny rose + pl": "#934042",
  "shiny rose gold": "#D6B89A",
  "shiny silk": "#D1C4BA",
  "shiny silk + rosé": "#D1C4BA",
  "shiny silver sl": "#BABEBF",
  "shiny silver or": "#BCB4BE",
  "scarlet": "#FCF1D0",
  "sebring": "#AA9E9C",
  "sebring + americano": "#AA9E9C",
  "sedona": "#C9782E",
  "sierra bro": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Sierra_Brownd_Gradient-Circle-01.png?v=1645045053",
  "sierra": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Sierra-Circle-01.png?v=1645045117",
  "silk": "#EBDFDF",
  "silk + rose": "#EBDFDF",
  "silver": "#B7B7B7",
  "slate": "#6B7879",
  "slate + cold brew": "#6B7879",
  "static": "#98958A",
  "sterling": "#E0DEE6",
  "sunrise": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Sunrise-Circle-01.png?v=1645045244",
  "split brus": "#B2BCBB",
  "split ligh": "#BCBCB2",
  "split moab tortoise": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Moab_Tortoise-Circle-01.png?v=1645044398",
  "split summ": "#D0AE91",
  "split": "#835027",
  "spruce": "#ADB6C4",
  "spruce + cold brew": "#ADB6C4",
  "stingray": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Stingray-Circle-01.png?v=1645045160",
  "stingray + cold brew": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Stingray-Circle-01.png?v=1645045160",
  "stout": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Stout-Circle-01.png?v=1645045202",
  "stout + brindle tortoise": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Stout-Circle-01.png?v=1645045202",
  "summer": "#FFDCA3",
  "sunflo": "#FFB301",
  "swim": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Swim-Circle.png?v=1676420743",
  "tahoe tortoise": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Tahoe_Tortoise-Circle-01.png?v=1645045287",
  "tahoe tortoise + rose": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Tahoe_Tortoise-Circle-01.png?v=1645045287",
  "tamarin": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Tamarin-Circle-01.png?v=1645045357",
  "tamarin tortoise": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Tamarin-Diamond-01.png?v=1645045388",
  "tawny + brindle tortoise": "https://cdn.shopify.com/s/files/1/0008/6156/9085/files/Tawny-Brindle-Tortoise-Color-Swatch-Circle.png?v=1665533418",
  "teal gradient mirror": "#7CC4B1",
  "tokyo champagne": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Tokyo_Tortoise-Circle-01.png?v=1645045408",
  "tokyo hone": "#BA6900",
  "tokyo tortoise": "//cdn.shopify.com/s/files/1/0008/6156/9085/files/Tokyo_Tortoise-Circle-01.png?v=1645045408",
  "twilight": "#55677B",
  "umber": "#764D32",
  "umber + kelp": "#764D32",
  "updraf": "#7E8191",
  "used": "#8B554A",
  "villa": "#E2D3AB",
  "vibrant brown polarized": "#6B7879",
  "white": "#F4F4F4",
  "yuzu": "https://cdn.shopify.com/s/files/1/0008/6156/9085/files/Yuzu-Color-Swatch-Circle.png?v=1665533442",
  "zucchi": "#236441"
}

